import { CarOutlined } from "@ant-design/icons";
import { CrudOp, projectOverviewAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { Translations, ViewIsAuthorized, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { ProjectManagementView } from "./lazy-view";

const translations: Translations = { de, en };
const isAuthorized: ViewIsAuthorized = (authHelperCreator) => {
  const authHelper = authHelperCreator(projectOverviewAuthScope);
  return authHelper.evaluate(CrudOp.READ);
};

export const projectManagementViewKey = "project/project-management";
export const projectManagementViewModule: ViewModule = {
  viewKey: projectManagementViewKey,
  viewEl: <ProjectManagementView/>,
  displayNameI18nKey: "projectManagement:viewName",
  menuIconEl: <CarOutlined/>,
  isAuthorized,
  translations,
};
